import React from "react";
import { useGlobalProgress } from "@/shared/contexts/use-global-progress";

export const ProgressBar: React.FC = () => {
  const { isAnySyncActive, progress } = useGlobalProgress();

  if (!isAnySyncActive) {
    return null;
  }

  return (
    <div className="fixed top-0 left-0 right-0 z-50">
      <div className="h-1 bg-neutral-800">
        <div
          className="h-full bg-gradient-to-r from-blue-500 to-purple-500 transition-all duration-300 ease-out"
          style={{
            width: progress > 0 ? `${progress}%` : "100%",
            animation: progress === 0 ? "pulse 2s infinite" : "none",
          }}
        />
      </div>
    </div>
  );
};
